import { useQuery } from "@tanstack/react-query";
import Routes from "./routes";
import apiClient from "@apis/index";
import { KnowiResponse } from "@src/types/KnowiDashboard";

export const useGetKnowiDashBoard = (
  isEnabled: boolean,
  widget_id?: string
) => {
  return useQuery({
    queryKey: ["GET_KNOWI", widget_id],
    enabled: !!widget_id && isEnabled,
    queryFn: () =>
      apiClient
        .get<KnowiResponse>(Routes.GET_KNOWI_DASHBOARD, {
          params: { widget_id: widget_id },
        })
        .then((data) => {
          return data;
        }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
